<template>
  <PolicyDetailsHeader :policyId="policyId"></PolicyDetailsHeader>
  <MotorPolicyDetails
    v-if="getLine === 'motor'"
    :policyId="policyId"
    :isQuote="false"
  ></MotorPolicyDetails>
  <EmobilPolicyDetails
    v-if="getLine === 'tech-insurance'"
    :policyId="policyId"
    :isQuote="false"
  ></EmobilPolicyDetails>
  <ShurPolicyDetails
    v-if="isShurLine(getLine)"
    :policyId="policyId"
    :line="getLine"
  ></ShurPolicyDetails>
  <LifePolicyDetails v-if="getLine === 'life'" :policyId="policyId"></LifePolicyDetails>
  <div class="payment">
    <PaymentDataComponent :policyId="policyId"></PaymentDataComponent>
    <PartnerAddressComp
      v-if="!isLifeContractAndOdsActive"
      :policyId="policyId"
      :partnerAddressId="route.params.partnerAddressId!.toString()"
      useCollapser="true"
      lines-whitelist="salutation, academicTitle, nobilityTitle, firstName, lastName, nameAffix, dateOfBirth, streetAndHouseNumber, additionalToAddress, zipcodeAndCity, country"
    ></PartnerAddressComp>
    <!--  AdvisorDetails only in ZKP  -->
    <AdvisorDetails :policyId="policyId" :useCollapser="true"></AdvisorDetails>
  </div>
  <Card>
    <template #content>
      <Collapser collapserTitle="Postfach">
        <template #collapserContent>
          <div class="remove-border">
            <PostboxList
              v-if="partnerProxyId"
              :partnerProxyId="partnerProxyId"
              :policyId="policyId"
              :isFilterActivated="false"
            ></PostboxList>
          </div>
        </template>
      </Collapser>
    </template>
  </Card>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import PolicyDetailsHeader from '@/components/policy/PolicyDetailsHeader.vue'
import MotorPolicyDetails from '@/components/motor/MotorPolicyDetails.vue'
import EmobilPolicyDetails from '@/components/emobil/EmobilPolicyDetails.vue'
import ShurPolicyDetails from '@/components/shur/ShurPolicyDetails.vue'
import PaymentDataComponent from '@/components/policy/PaymentDataComponent.vue'
import PartnerAddressComp from '@/components/partner-proxy/PartnerAddressComp.vue'
import LifePolicyDetails from '@/componentsTenant/life/LifePolicyDetails.vue'
import AdvisorDetails from '@/componentsTenant/partner-proxy/AdvisorDetails.vue'
import { isTrue } from '@/utils/CommonUtils'
import { Card, Collapser } from 'de-zurich-ui-library'
import { useRoute } from 'vue-router'
import PostboxList from '@/components/postbox/PostboxList.vue'
import { getPartnerProxyId } from '@/utils/KeycloakUtils'
import { usePoliciesStore } from '@/stores/policiesStore'

const route = useRoute()
const policiesStore = usePoliciesStore()

const policyId = ref(route.params.policyId!.toString())
const partnerProxyId = getPartnerProxyId()

const isLifeContractAndOdsActive = computed(() => {
  return (
    route.params.line === 'life' &&
    isTrue(globalThis.ENV_CONFIG?.FEATURE_FLAGS.LIFE.USE_ODS_COMPONENTS)
  )
})

const getLine = computed(() => {
  return route.params.line!.toString()
})

onMounted(() => {
  // set pre-selected policy id in store (in-memory, one-time) before navigating
  policiesStore.setPreSelectedPolicyId(policyId.value ?? '')
})

function isShurLine(line: string): boolean {
  const shurLines = [
    'accident',
    'building',
    'glass',
    'household',
    'legal-protection',
    'liability',
    'bundled-property',
    'transport'
  ]

  return shurLines.includes(line)
}
</script>

<style lang="scss" scoped>
.remove-border {
  border: none;
}

.remove-border :deep(.card) {
  margin-bottom: 0 !important;
  border: 0 !important;
}

.remove-border :deep(.card__header) {
  padding-top: 0 !important;
}

.remove-border :deep(.card__footer) {
  padding-bottom: 0 !important;
}

.remove-border :deep(.card__header),
.remove-border :deep(.card__content),
.remove-border :deep(.card__footer) {
  padding: 0 !important;
}
</style>
